import React, { useEffect, useState, useRef } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import EE from '@/common/event';
import Local from '@/common/helper/local';

const cacheKey = 'PLAN_QUESTION_COUNTDOWN_TIMEOUT';
const setCacheCount = (id, val, clear) => {
  const cacheData = Local.getItem(cacheKey) || {};
  if (clear) {
    try {
      delete cacheData[id];
    } catch (error) {}
  } else {
    cacheData[id] = val;
  }
  Local.setItem(cacheKey, cacheData, 'today');
};
const CountdownBtn = observer(props => {
  const cacheData = Local.getItem(cacheKey) || {};
  const { planStepId, timeout, overrun, disable } = props;
  const [count, setCount] = useState(timeout);
  const [pause, setPause] = useState(false);
  const isOver = count < 1;
  const timerRef = useRef(null);

  useEffect(() => {
    if (pause) {
      clearInterval(timerRef.current);
    } else {
      clearInterval(timerRef.current);
      timerRef.current = setInterval(() => {
        setCount(_count => {
          const count = _count - 1;
          setCacheCount(planStepId, count);
          return count;
        });
      }, 1000);
    }
  }, [pause]);

  useEffect(() => {
    if (isOver || disable) {
      setPause(true);
      clearInterval(timerRef.current);
      setCacheCount(planStepId, 0, true);
    }
    if (isOver) {
      overrun && overrun();
    }
  }, [isOver]);

  useEffect(() => {
    setCount(cacheData[planStepId] || timeout);
    const reload = () => {
      setPause(true);
      clearInterval(timerRef.current);
      setCacheCount(planStepId, 0, true);
    };
    EE.on('confirm_countdown_pause', setPause);
    EE.on('confirm_countdown_reload', reload);

    return () => {
      EE.off('confirm_countdown_pause', setPause);
      EE.off('confirm_countdown_reload', reload);
    };
  }, []);

  if (isOver || disable) return null;

  return <span>（{count}s）</span>;
});
export default CountdownBtn;
